// Importing necessary action type constants
import * as ACTION from '../../Redux.constants';

/**
 * DesignReducer
 * A reducer function to manage the state related to the design views.
 * 
 * @param {object} state - Represents the current state of the design views.
 * @param {object} action - Represents the dispatched action.
 * @returns {object} - Returns the new state based on the action.
 */
export function DesignReducer(state = {}, action) {
  switch (action.type) {
    // When the design level is set, it restructures and returns the design chapter data.
    case ACTION.SET_LEVEL:
      return getDesignChapter(action.payload.DESIGN_CHAPTER);
      
    // When the design tab is set, it updates the current view and archives the previous view.
    case ACTION.DESIGN_SET_TAB:
      return {
        ...state,
        [state.currentView.viewType]: state.currentView,  // Archive the current view.
        currentView: state[action.payload],               // Update to the new view.
      };
    
    // For any other action, simply return the current state.
    default:
      return state;
  }
}

/**
 * getDesignChapter
 * Helper function to structure the data for the design chapter.
 * 
 * @param {object} param0 - Represents the destructured design chapter data.
 * @returns {object} - Returns the structured design chapter data.
 */
function getDesignChapter({currentView, allViews, ...rest}) {
  return {
    ...rest,                         // Spread the rest of the properties.
    ...allViews,                     // Spread all the view data.
    currentView: allViews[currentView],  // Set the current view.
    longestStreak: 0,                // Initialize the longest streak.
  };
}
